<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'
import { toSmallNum } from "@/utils/bigNumberTran.js"
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '3.3rem'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    xAxis:{
      type:Array,
      default:() => {
        return [];
      }
    },
    series:{
      type:Array,
      default:() => {
        return [];
      }
    }
  },
  data() {
    return {
      chart: null,
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions()
    },
    setOptions() {
      this.chart.setOption({
        xAxis: {
          data: this.xAxis,
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#D9DDE3",
              width: 1,
              type: "solid"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#CECECE",
            }
          }
        },
        grid: {
          left: 40,
          right: 40,
          bottom: 50,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          // axisPointer: {
          //   type: 'cross'
          // },
          padding: [5, 10],
          // formatter: function (params) {
          //   let returnData = "";
          //   for (let i=0;i<params.length;i++){
          //     if (params[i].seriesName!=""){
          //       let indexColor = params[i].color;
          //       returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:'+ indexColor +'"></span>';
          //       returnData += params[i].seriesName +": " + toSmallNum(params[i].value) + "</br>";
          //     }
          //   }
          //   return returnData;
          // }
        },
        yAxis: {
          axisTick: {
            show: false
          },
          position:"right",
          axisLine:{
            show: true,
            lineStyle: {
              color: "#D9DDE3",
              width: 1,
              type: "solid"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#CECECE",
            },
            // formatter: function (data) {
            //   return toSmallNum(data)
            // }
          }
        },
        legend: {
          icon:"rect",
          itemWidth:16,
          itemHeight:3,
          data: [this.series[0] && this.series[0].name, this.series[1] && this.series[1].name],
          left: 'left',
          top: '-5'
        },
        series: [{
          name: this.series[0] && this.series[0].name,
          itemStyle: {
            normal: {
              color: '#4E83FE',
              lineStyle: {
                color: '#4E83FE',
                width: 2
              }
            }
          },
          type: 'line',
          data: this.series[0]&&this.series[0].data || [],
          animationDuration: 2800,
          animationEasing: 'cubicInOut',
          smooth:false
        },
        {
          name: this.series[1] && this.series[1].name,
          type: 'line',
          itemStyle: {
            normal: {
              color: '#929DAD',
              lineStyle: {
                color: '#929DAD',
                width: 2
              },
              areaStyle: {
                color: '#f3f8ff'
              }
            }
          },
          data: this.series[1]&&this.series[1].data || [],
          animationDuration: 2800,
          animationEasing: 'quadraticOut',
          smooth:false
        }]
      })
    }
  },
  watch:{
    series:{
      deep: true,
      handler(){
        this.setOptions();
      }
    }
  }
}
</script>
